// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-5c2d0ec4]{padding:0 .5rem;min-height:90vh;display:flex;flex-direction:column;justify-content:center;align-items:center}.loading .label-loading[data-v-5c2d0ec4]{text-align:center;margin-bottom:3rem;font-weight:700}.loading .loading-icon[data-v-5c2d0ec4]{font-size:5rem}", ""]);
// Exports
module.exports = exports;
